module.exports = __webpack_public_path__ + "static/media/loadingGif.1e4c75d6.gif";